export const NEWSLETTER_AUDIENCES = [
  { value: "parent", de: "Für meine Mutter / meinen Vater", en: "For my mother / father" },
  { value: "grandparent", de: "Für meine Großmutter / meinen Großvater", en: "For my grandmother / grandfather" },
  { value: "partner", de: "Für meine Partnerin / meinen Partner", en: "For my partner" },
  { value: "self", de: "Für mich selbst", en: "For myself" },
  { value: "other", de: "Für eine andere nahestehende Person", en: "For another person close to me" },
  { value: "professional", de: "Beruflich / für eine Pflegeeinrichtung oder Organisation", en: "Professionally / for a care facility or organization" },
];

export const NEWSLETTER_AGE_GROUPS = [
  { value: "under_30", de: "Unter 30 Jahre", en: "Under 30" },
  { value: "30_39", de: "30–39 Jahre", en: "30–39" },
  { value: "40_49", de: "40–49 Jahre", en: "40–49" },
  { value: "50_59", de: "50–59 Jahre", en: "50–59" },
  { value: "60_69", de: "60–69 Jahre", en: "60–69" },
  { value: "70_79", de: "70–79 Jahre", en: "70–79" },
  { value: "80_plus", de: "80 Jahre oder älter", en: "80 or older" },
  { value: "prefer_not", de: "Möchte ich nicht angeben", en: "Prefer not to say" },
];

export const NEWSLETTER_BENEFITS = [
  { value: "companionship", de: "Mehr Gesellschaft im Alltag", en: "More companionship in everyday life" },
  { value: "independence", de: "Mehr Selbstständigkeit", en: "More independence" },
  { value: "family_contact", de: "Einfacher Kontakt zur Familie", en: "Easier contact with family" },
  { value: "daily_support", de: "Erinnerungen und Unterstützung im Alltag", en: "Reminders and everyday support" },
  { value: "stay_active", de: "Geistig und körperlich aktiv bleiben", en: "Staying mentally and physically active" },
  { value: "safety", de: "Mehr Sicherheit durch mögliche Notfallfunktionen", en: "More safety through possible emergency features" },
  { value: "care_relief", de: "Unterstützung und Entlastung in der Pflege", en: "Support and relief in care" },
  { value: "learn_more", de: "Ich möchte SteffiCare erst einmal kennenlernen", en: "I would first like to get to know SteffiCare" },
];

export function newsletterOptionLabel(options, value, lang = "de") {
  return options.find((option) => option.value === value)?.[lang] || value;
}
